import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  constructor(private sanitizer: DomSanitizer) {}

  /**
   * Creates a trusted object URL from the Blob.
   * WARNING: calling this method with untrusted user data exposes your application to XSS security risks!
   * @param  blob Data to wrap into object URL
   * @returns URL string
   */
  createTrustedUrl(blob: Blob): string {
    const url = window.URL.createObjectURL(blob);
    return <string>this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
